import { Component } from "react";
import DataResult from "../data/bean/data_result";
import GeneralWebService from "../service/general_web_service";
import DocumentWebService from "../service/document_web_service";

class DocumentBloc extends Component {

  static async getPdfByCode(id,docCode, pdf_code) {
    let resp;
    // alert(id)
    // alert(docCode)
    if(docCode == "generateProposalForm") {
      resp = await DocumentWebService.getPdfProposalByCode(id,docCode);
    }
    else if(docCode == "privacyPolicySummary") {
      resp = await DocumentWebService.getPrivayPolicySummaryByCode(pdf_code);
    }
    else {
      resp = await DocumentWebService.getPdfByCode(id,docCode);
    }

    if (resp.data) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, null);
    }
  }
 
  static async deleteUploadDocsById(payload){
    let resp = await DocumentWebService.deleteUploadDocs(payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }
  
  static async saveUploadDocs(entity,payload){
    let resp = await DocumentWebService.saveUploadDocs(entity,payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getUploadDocsById(code,payload){
    let resp = await DocumentWebService.getUploadDocsById(code,payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getMrttDocsById(code, payload){
    let resp = await DocumentWebService.getMrttDocsById(code,payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getUploadDocsByIdClient(code,payload){
    let resp = await DocumentWebService.getUploadDocsByIdClient(code,payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getUploadDocs(code,payload){
    let resp = await DocumentWebService.getUploadDocs(code,payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getPDF(id) {
    let resp = await DocumentWebService.getPDFAsset(id);
    if (resp.data) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, null);
    }
  }

  static async saveClientSignatureImage(payload, proposalId){
    let userId =  JSON.parse(localStorage.getItem("userId"));
    let resp = await DocumentWebService.saveClientSignatureImage(payload, proposalId,userId);
    if (resp.success) {
      console.log(resp)
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

}

export default DocumentBloc;
